import ServiceContainer from "../ServiceContainer";
import TypesSelectorSubscriber from "./subscribers/TypesSelectorSubscriber";
import BedroomsLinearSelectorFilterSubscriber from "./subscribers/BedroomsLinearSelectorFilterSubscriber";
import SearchBoxSubscriber from "./subscribers/SearchBoxSubscriber";
import SimilarListingsSubscriber from "./subscribers/SimilarListingsSubscriber";
import {ListingsSubscriber} from "./subscribers/ListingsSubscriber";
import FiltersModalSubscriber from "./subscribers/FiltersModalSubscriber";
import SimilarListingsService from "./services/SimilarListingsService";
import DuplicatedClickListingService from "./services/DuplicatedClickListingService";
import {RedirectToUserSearch} from "../core/url/services/RedirectToUserSearch";
import {
    FullScreenModalBlock,
    GetNumberOfListingsAjax,
    WindowService
} from "../core/url/services/GetNumberOfListingsAjax";
import {DocumentRedirectToUrl} from "../core/url/RedirectToUrl";
import {EventBus} from "../../../common/ts/events/EventBus";
import GoogleDisplay from "./components/googleDisplay";
import dom from "../../../common/ts/core/dom";
import GoogleAfs from "../afs/googleAfs";
import {VisitedCookie} from "./VisitedCookie";
import {ApiListingsRepository} from "../core/api/ApiRepository";
import SortBySelectorSubscriber from "./subscribers/SortBySelectorSubscriber";
import PriceRangeSelectorSubscriber from "./subscribers/PriceRangeSelectorSubscriber";
import BathroomsLinearSelectorFilterSubscriber from "./subscribers/BathroomsLinearSelectorFilterSubscriber";
import AreaRangeSelectorSubscriber from "./subscribers/AreaRangeSelectorSubscriber";
import PropertyTypesSelectorSubscriber from "./subscribers/PropertyTypesSelectorSubscriber";
import CitiesSelectorSubscriber from "./subscribers/CitiesSelectorSubscriber";
import RegionsSelectorSubscriber from "./subscribers/RegionsSelectorSubscriber";
import {ToggleDescription} from "./subscribers/ToggleDescription";
import {ListingVisited} from "./subscribers/ListingVisited";
import FeatureFlags from "../../../common/ts/FeatureFlags";
import {FiltersSubscriber} from "./subscribers/FiltersSubscriber";
import CityAreasSelectorSubscriber from "./subscribers/CityAreasSelectorSubscriber";
import {ListingsFilteringResponseSubscriber} from "./subscribers/ListingFilteringResponseSubscriber";
import ClearAllFormFiltersSubscriber from "./subscribers/ClearAllFormFiltersSubscriber";
import ShowResultsSubscriber from "./subscribers/ShowResultsSubscriber";
import Sticky from "./components/Sticky";
import PointsOfCapture from "./components/retention/pointsOfCapture/PointsOfCapture";
import {GoogleOneTapSubscriber} from "./subscribers/GoogleOneTapSubscriber";
import AdFormService from "../../../common/ts/services/AdFormService";
import UserContactDataStorageService from "../../../common/ts/services/UserContactDataStorageService";
import TrackFilterWithGoogleAnalyticsService from "./services/TrackFilterWithGoogleAnalyticsService";
import GoogleTrackingFactory from "../../../common/ts/core/tracking/GoogleTrackingFactory";
import {Brand} from "../../../common/ts/types/Brand";
import {Country} from "../../../common/ts/types/Country";
import {TopLeftPointOfCapture} from "./components/retention/pointsOfCapture/TopLeftPointOfCapture";
import {BottomPointOfCapture} from "./components/retention/pointsOfCapture/BottomPointOfCapture";
import {AutoOpenModalPointOfCapture} from "./components/retention/pointsOfCapture/AutoOpenModalPointOfCapture";
import ConsentSubscriber from "./subscribers/ConsentSubscriber";
import {MobileFixedBottomPointOfCapture} from "./components/retention/pointsOfCapture/MobileFixedBottomPointOfCapture";
import CookieService from "../../../common/ts/services/CookieService";
import ClearAllFiltersAndReloadSubscriber from "./subscribers/ClearAllFiltersAndReloadSubscriber";
import TrackFiltersWebTrackingEventsService from "./services/TrackFiltersWebTrackingEventsService";

const eventBus: EventBus = EventBus.getInstance()
const featureFlags: FeatureFlags = new FeatureFlags()
const visitedCookie: VisitedCookie = new VisitedCookie()
const duplicateClickListingService: DuplicatedClickListingService = new DuplicatedClickListingService()
const modalBlock = new FullScreenModalBlock('filters-modal-block')
const adFormService = new AdFormService()
const userContactDataStorageService = new UserContactDataStorageService()
const cookieService = new CookieService()

const redirectToUserSearch: RedirectToUserSearch = new RedirectToUserSearch(new DocumentRedirectToUrl);
const getNumberOfListingsAjax = new GetNumberOfListingsAjax(new WindowService(), eventBus, modalBlock);
const topLeftPointOfCapture: TopLeftPointOfCapture = new TopLeftPointOfCapture(eventBus, userContactDataStorageService);
const bottomPointOfCapture: BottomPointOfCapture = new BottomPointOfCapture(eventBus, userContactDataStorageService);
const autoOpenModalPointOfCapture: AutoOpenModalPointOfCapture = new AutoOpenModalPointOfCapture(eventBus, userContactDataStorageService);
const mobileFixedBottomPointOfCapture: MobileFixedBottomPointOfCapture = new MobileFixedBottomPointOfCapture(eventBus, userContactDataStorageService, cookieService);
// In Trovit not is necessary to pass the brand and country
const googleTracking = GoogleTrackingFactory.createFor(
    "" as Brand,
    "" as Country
)
const trackFilterWithGoogleAnalyticsService: TrackFilterWithGoogleAnalyticsService = new TrackFilterWithGoogleAnalyticsService(googleTracking);
const trackFilterWebTrackingService: TrackFiltersWebTrackingEventsService = new TrackFiltersWebTrackingEventsService(eventBus);
export const serviceContainer: ServiceContainer = new ServiceContainer({
    [AreaRangeSelectorSubscriber.name]: () => new AreaRangeSelectorSubscriber(eventBus, redirectToUserSearch, trackFilterWithGoogleAnalyticsService, trackFilterWebTrackingService),
    [AreaRangeSelectorSubscriber.name + '.ajax']: () => new AreaRangeSelectorSubscriber(eventBus, getNumberOfListingsAjax, trackFilterWithGoogleAnalyticsService, trackFilterWebTrackingService),
    [BathroomsLinearSelectorFilterSubscriber.name]: () => new BathroomsLinearSelectorFilterSubscriber(
        eventBus,
        redirectToUserSearch,
        trackFilterWithGoogleAnalyticsService,
        trackFilterWebTrackingService
    ),
    [BathroomsLinearSelectorFilterSubscriber.name + '.ajax']: () => new BathroomsLinearSelectorFilterSubscriber(
        eventBus,
        getNumberOfListingsAjax,
        trackFilterWithGoogleAnalyticsService,
        trackFilterWebTrackingService
    ),
    [BedroomsLinearSelectorFilterSubscriber.name]: () => new BedroomsLinearSelectorFilterSubscriber(
        eventBus,
        redirectToUserSearch,
        trackFilterWithGoogleAnalyticsService,
        trackFilterWebTrackingService
    ),
    [BedroomsLinearSelectorFilterSubscriber.name + '.ajax']: () => new BedroomsLinearSelectorFilterSubscriber(
        eventBus,
        getNumberOfListingsAjax,
        trackFilterWithGoogleAnalyticsService,
        trackFilterWebTrackingService
    ),

    [CitiesSelectorSubscriber.name]: () => new CitiesSelectorSubscriber(eventBus, redirectToUserSearch, trackFilterWithGoogleAnalyticsService, trackFilterWebTrackingService),
    [CitiesSelectorSubscriber.name + '.ajax']: () => new CitiesSelectorSubscriber(eventBus, getNumberOfListingsAjax, trackFilterWithGoogleAnalyticsService, trackFilterWebTrackingService),
    [CityAreasSelectorSubscriber.name]: () => new CityAreasSelectorSubscriber(eventBus, redirectToUserSearch, trackFilterWithGoogleAnalyticsService, trackFilterWebTrackingService),
    [CityAreasSelectorSubscriber.name + '.ajax']: () => new CityAreasSelectorSubscriber(eventBus, getNumberOfListingsAjax, trackFilterWithGoogleAnalyticsService, trackFilterWebTrackingService),
    [FiltersSubscriber.name]: () => new FiltersSubscriber(redirectToUserSearch, trackFilterWithGoogleAnalyticsService),
    [FiltersModalSubscriber.name]: () => new FiltersModalSubscriber(eventBus, redirectToUserSearch, modalBlock),
    [GoogleDisplay.name]: () => new GoogleDisplay(window.googletag, dom),
    [GoogleAfs.name]: () => new GoogleAfs(window._googCsa, dom),
    [ListingVisited.name]: () => new ListingVisited(eventBus, visitedCookie),
    [ListingsSubscriber.name]: () => new ListingsSubscriber(
        eventBus,
        visitedCookie,
        duplicateClickListingService
    ),
    [PriceRangeSelectorSubscriber.name]: () => new PriceRangeSelectorSubscriber(eventBus, redirectToUserSearch, trackFilterWithGoogleAnalyticsService, trackFilterWebTrackingService),
    [PriceRangeSelectorSubscriber.name + '.ajax']: () => new PriceRangeSelectorSubscriber(eventBus, getNumberOfListingsAjax, trackFilterWithGoogleAnalyticsService, trackFilterWebTrackingService),
    [PropertyTypesSelectorSubscriber.name]: () => new PropertyTypesSelectorSubscriber(eventBus, redirectToUserSearch, trackFilterWithGoogleAnalyticsService, trackFilterWebTrackingService),
    [PropertyTypesSelectorSubscriber.name + '.ajax']: () => new PropertyTypesSelectorSubscriber(eventBus, getNumberOfListingsAjax, trackFilterWithGoogleAnalyticsService, trackFilterWebTrackingService),
    [RegionsSelectorSubscriber.name]: () => new RegionsSelectorSubscriber(eventBus, redirectToUserSearch, trackFilterWithGoogleAnalyticsService, trackFilterWebTrackingService),
    [RegionsSelectorSubscriber.name + '.ajax']: () => new RegionsSelectorSubscriber(eventBus, getNumberOfListingsAjax, trackFilterWithGoogleAnalyticsService, trackFilterWebTrackingService),
    [SearchBoxSubscriber.name]: () => new SearchBoxSubscriber(redirectToUserSearch, trackFilterWebTrackingService),
    [SimilarListingsSubscriber.name]: () => new SimilarListingsSubscriber(
        eventBus,
        new SimilarListingsService(eventBus, new ApiListingsRepository()),
        visitedCookie
    ),
    [SortBySelectorSubscriber.name]: () => new SortBySelectorSubscriber(eventBus, redirectToUserSearch, trackFilterWithGoogleAnalyticsService, trackFilterWebTrackingService),
    [ToggleDescription.name]: () => new ToggleDescription(eventBus),
    [TypesSelectorSubscriber.name]: () => new TypesSelectorSubscriber(eventBus, redirectToUserSearch, trackFilterWithGoogleAnalyticsService, trackFilterWebTrackingService),
    [ListingsFilteringResponseSubscriber.name]: () => new ListingsFilteringResponseSubscriber(eventBus),
    [ShowResultsSubscriber.name]: () => new ShowResultsSubscriber(redirectToUserSearch, modalBlock),
    [ClearAllFormFiltersSubscriber.name]: () => new ClearAllFormFiltersSubscriber(getNumberOfListingsAjax),
    [ClearAllFiltersAndReloadSubscriber.name]: () => new ClearAllFiltersAndReloadSubscriber(redirectToUserSearch),
    [Sticky.name]: () => new Sticky(),
    [PointsOfCapture.name]: () => new PointsOfCapture(adFormService, userContactDataStorageService, cookieService, [topLeftPointOfCapture, bottomPointOfCapture, autoOpenModalPointOfCapture, mobileFixedBottomPointOfCapture]),
    [GoogleOneTapSubscriber.name]: () => new GoogleOneTapSubscriber(eventBus, adFormService),
    [ConsentSubscriber.name]: () => new ConsentSubscriber(eventBus),
});
